import s from '@/components/layouts/WorkspaceLayout/WorkspaceLayout.module.scss';
import { Sidebar } from '../../Sidebar/Sidebar';
import classNames from 'classnames';
import { SidebarLinkConditional } from '@/types/Sidebar';
import { getTopSidebarLinks, getBottomSidebarLinks } from '@/routes/navigation';

interface WorkspaceSidebarProps {
  isExpanded: boolean;
  isDataforSeo: boolean;
  workspaceId: string;
  hasSelectedOrganization: boolean;
}

export const WorkspaceSidebar = ({
  isExpanded,
  isDataforSeo,
  workspaceId,
  hasSelectedOrganization,
}: WorkspaceSidebarProps) => {
  const links = getTopSidebarLinks(isDataforSeo);
  const bottomLinks: SidebarLinkConditional[] = getBottomSidebarLinks(
    workspaceId,
    hasSelectedOrganization,
  );

  return (
    <>
      <Sidebar links={links} bottomLinks={bottomLinks} />
      <div
        className={classNames({
          [s.sidebarFillerExpanded]: isExpanded,
          [s.sidebarFillerCollapsed]: !isExpanded,
        })}
      ></div>
    </>
  );
};
